// src/lib/proj4-setup.ts
import * as proj4ns from "proj4";
import defs from "proj4js-definitions";
const proj4 = (proj4ns as any).default ?? (proj4ns as any);
proj4.defs(defs);
(window as any).proj4 = proj4;
export default proj4;